"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _1 = require(".");
var browser_1 = require("bernie-plugins/dist/execute/browser");
var logger_1 = require("./logger");
var get_client_plugins_1 = require("bernie-plugins/dist/load/get-client-plugins");
var bernie_logger_1 = require("bernie-logger");
var logger = logger_1.ClientLogger.getLoggerWithIdentifier('bernie.client.entry');
(function () {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var error_1, error_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, browser_1.onBrowserInit)((0, get_client_plugins_1.getClientPlugins)(), { logger: logger, state: window.__PLUGIN_STATE__ })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.logEvent(new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.CRITICAL, 'WEBPACK_ENTRY_EXECUTE_ON_BROWSER_ENTRY_FAILURE'), error_1);
                    return [3 /*break*/, 3];
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, (0, _1.clientHydration)()];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    error_2 = _a.sent();
                    logger.logEvent(new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.CRITICAL, 'WEBPACK_ENTRY_CLIENT_HYDRATION_FAILURE'), error_2);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
})();
//# sourceMappingURL=webpack-entry.js.map